export default "__VITE_ASSET__na0WSkns__"